/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shifting to frame +2 of AATGGCC reads ATG GCC → M A.`)
};

const es_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiando al marco +2 de AATGGCC se lee ATG GCC → M A.`)
};

const de_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschiebung zu Raster +2 von AATGGCC liest ATG GCC → M A.`)
};

const nl_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschuiven naar frame +2 van AATGGCC leest ATG GCC → M A.`)
};

const fr_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le passage au cadre +2 de AATGGCC lit ATG GCC → M A.`)
};

const it_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spostandosi alla fase +2 di AATGGCC si legge ATG GCC → M A.`)
};

const pt_br2_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocando para o quadro +2 de AATGGCC, lê-se ATG GCC → M A.`)
};

const pt_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passando para a grelha +2 de AATGGCC lê-se ATG GCC → M A.`)
};

const ja_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AATGGCCの読み枠+2にシフトすると ATG GCC → M A。`)
};

const zh_translate_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 AATGGCC 移至 +2 阅读框读取为 ATG GCC → M A。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_ex3", locale)
	if (locale === "en") return en_translate_ex3(inputs)
	if (locale === "es") return es_translate_ex3(inputs)
	if (locale === "de") return de_translate_ex3(inputs)
	if (locale === "nl") return nl_translate_ex3(inputs)
	if (locale === "fr") return fr_translate_ex3(inputs)
	if (locale === "it") return it_translate_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_translate_ex3(inputs)
	if (locale === "pt") return pt_translate_ex3(inputs)
	if (locale === "ja") return ja_translate_ex3(inputs)
	return zh_translate_ex3(inputs)
};